import { FileDescriptorRead, PublicationVersionDescriptor } from "@nens/rana/api-v1";

import { FileDescriptorDataType, FileDescriptorDataTypesMap } from "@/types/descriptor-types";

export function isTypedDescriptor<T extends FileDescriptorDataType>(
  descriptor: FileDescriptorRead | PublicationVersionDescriptor | undefined,
  type: T
): descriptor is FileDescriptorDataTypesMap[T] {
  return (
    !!descriptor &&
    descriptor.dataType === type &&
    descriptor.status?.id === "completed" &&
    !!descriptor?.meta // Meta can be null in invalid descriptors.
  );
}
